const Home = () => import('@/views/vph/home') // 首页
const Search = () => import('@/views/vph/search') // 搜索
const Mine = () => import('@/views/vph/mine') // 我的

export default [
  { path: '/vph', name: 'vphHome', component: Home, meta: { isTab: false, keepAlive: true, title: '唯品会热卖' } },
  { path: '/vph/search', name: 'vphSearch', component: Search, meta: { isTab: false, keepAlive: true, title: '搜索' } },
  { path: '/vph/mine', name: 'vphMine', component: Mine, meta: { isTab: false, keepAlive: true, requireAuth: false, title: '我的' } },
]